<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    id: {
        type: Number,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const componentId = computed(() => {
    const tableName = `component_${props.id}`;
    return store.state.components.componentIds[tableName] || 0;
});

// --- Methods ---

const openFieldsModal = () => {
    store.dispatch('modals/show', {
        componentName: 'ContentTypeFieldsModal',
        obj: {
            componentId: componentId.value
        }
    });
};
</script>

<template>
    <Button v-if="componentId" class="btn-sm" @click.native="openFieldsModal">
        Fields
    </Button>
</template>


<style scoped>
/* Scoped styles preserved empty */
</style>